<template>
  <div class="table-container" v-if="showMatrixScore">
    <a-table :data-source="rowItem" bordered :pagination="false" size="small">
      <a-table-column className="min-width-column" fixed="left">
        <template v-slot:default="props">
          <div class="item-name" v-if="isPreview">
            <a-input
              class="input-class"
              v-model:value="rowItem[props.renderIndex].rowItem"
              @blur="updataMatrixScore"
              size="small"
            />
            <a-tooltip :title="$t('ep_admin_btns_delete')">
              <DeleteOutlined
                v-if="rowItem.length > 1"
                class="delect-icon"
                @click="delOption(props.renderIndex, 'rowItem')"
              />
            </a-tooltip>
          </div>
          <span v-else>{{ rowItem[props.renderIndex].rowItem }}</span>
        </template>
      </a-table-column>
      <a-table-column v-for="(item, index) in columnItem" :key="index" className="min-width-column">
        <template #title>
          <div class="item-name" v-if="isPreview">
            <a-input
              class="input-class"
              v-model:value="columnItem[index].columnItem"
              @blur="updataMatrixScore"
              size="small"
            />
            <!-- <a-tooltip :title="$t('ep_admin_btns_delete')">
              <DeleteOutlined
                v-if="columnItem.length > 1"
                class="delect-icon"
                @click="delOption(index, 'columnItem')"
              />
            </a-tooltip> -->
          </div>
          <span v-else>{{ item.columnItem }}</span>
        </template>
        <template #default="props">
          <Rate
            :disabled="isPreview || disabled"
            :update="update"
            :value="rowItem[props.renderIndex].column[index].score"
            @updataMatrixScore="e => updataMatrixScore(e, rowItem[props.renderIndex].column[index])"
          />
        </template>
      </a-table-column>
    </a-table>
  </div>
  <div class="add-score" v-if="isPreview && showMatrixScore">
    <a-button type="link" size="small" @click="addRow" :disabled="rowItem.length > 9"
      >+ {{ $t('ep_admin_form_matrix_rows') }}</a-button
    >
    <!-- <a-button type="link" size="small" @click="addColumn" :disabled="columnItem.length > 4"
      >+ {{ $t('ep_admin_form_scoring_items') }}</a-button
    > -->
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch, computed } from 'vue'
import cloneDeep from 'lodash/cloneDeep'
import Rate from './Rate.vue'
const props = defineProps({
  isPreview: {
    required: true,
    type: Boolean,
    default: false
  },
  data: {
    required: true,
    type: Object,
    default: {}
  },
  update: {
    required: true,
    type: Boolean,
    default: false
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['updataMatrixScore'])
const showMatrixScore = ref(false)

const columnItem = computed(() => {
  return rowItem.value[0].column
})

const rowItem = ref([
  {
    rowItem: 'Matrix Row 1',
    column: [
      {
        columnItem: 'Score 1',
        score: 0
      }
    ]
  }
])

const addRow = () => {
  if (rowItem.value.length > 10) return
  rowItem.value.push({
    rowItem: `Matrix Row ${rowItem.value.length + 1}`,
    column: cloneDeep(columnItem.value)
  })
  updataMatrixScore()
}

// const addColumn = () => {
//   if (columnItem.value.length > 5) return
//   rowItem.value.forEach(item => {
//     item.column.push({
//       columnItem: `Score ${item.column.length + 1}`,
//       score: 0
//     })
//   })
//   updataMatrixScore()
// }

const delOption = (index: number, type: string) => {
  if (type === 'rowItem') {
    rowItem.value.splice(index, 1)
  } else {
    rowItem.value.forEach(item => {
      item.column.splice(index, 1)
    })
  }
  updataMatrixScore()
}

const updataMatrixScore = (val: any, item: any) => {
  if (props.isPreview) {
    rowItem.value.forEach(item => {
      item.column = cloneDeep(columnItem.value)
    })
  } else {
    item.score = val
  }
  emit('updataMatrixScore', cloneDeep(rowItem.value))
}

const initData = () => {
  rowItem.value = cloneDeep(props.data.fieldContent)
}

onMounted(() => {
  if (props.data.fieldValue) {
    rowItem.value = props.data.fieldValue
  } else {
    initData()
  }
  showMatrixScore.value = true
})

watch(
  () => props.data.fieldContent,
  value => {
    if (!props.isPreview) {
      rowItem.value = cloneDeep(value)
    }
  },
  {
    deep: true
  }
)
</script>

<style lang="less" scoped>
.table-container {
  width: 100%;
  overflow-x: auto;

  .item-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(0, 0, 0, 0.85);

    .delect-icon {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.45);
      &:hover {
        color: rgb(24, 144, 255);
      }
    }
  }
}
.add-score {
  margin-top: 8px;
  button {
    padding: 0;
    margin-right: 16px;
  }
}
.ant-rate {
  height: 20px;
  line-height: 20px;
}
.table-container::-webkit-scrollbar-track {
  background: #ffffff;
}
.table-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25); /* 滚动条的颜色 */
  border-radius: 8px; /* 圆角 */
}
:deep(.min-width-column) {
  min-width: 190px;
  background-color: #fff;
}
.input-class {
  background-color: transparent;
  border: 1px solid transparent;
  &:hover {
    border: 1px solid rgb(64, 169, 255);
  }
  &:focus {
    border: 1px solid #40a9ff;
    box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
    outline: 0;
  }
}
</style>
